import { useAppDispatch } from '@customer/store/hooks';
import { customerApi, QueryTag } from '@customer/store/api';
import { useCallback } from 'react';
import CasRefreshButton, {
  RefreshButtonControllerProps,
} from '@cas/components/inputs/refresh-button/RefreshButton';

export const RefreshButton = ({ tagsToClear }: RefreshButtonControllerProps<QueryTag>) => {
  const dispatch = useAppDispatch();

  const invalidateTagsCallback = useCallback(() => {
    dispatch(customerApi.util.invalidateTags(tagsToClear));
  }, [dispatch, tagsToClear]);

  return <CasRefreshButton invalidateTagsCallback={invalidateTagsCallback} />;
};

export default RefreshButton;
